import { createAsyncThunk } from '@reduxjs/toolkit';
import { AdobeAnalyticsUtil } from '../Views/Foundation/Common/AdobeAnalytics/AdobeAnalyticsUtil.js';
import CommerceApiFetchWrapper from '../Utils/CommerceApiFetchWrapper.js';
import { updateShippingMethod } from './ShippingHelper.js';
import { br_cartAddition, br_cartRemove } from '../../../Bloomreach/code/Events/BloomreachCart.js';
export const changeProductAmount = createAsyncThunk(
  'changeProductAmount',
  async ({ externalId, amount, adobeAnalyticsData }, { dispatch, rejectWithValue, getState }) => {
    const state = getState();
    const product = state.Cart.lineItems.find((x) => x.id === externalId);
    let result;
    //Free gift
    if (product.isFreeGift && amount > 1) {
      const data = {
        productIds: [product.sku],
        quantity: 1,
      };
      let updatedCart = await CommerceApiFetchWrapper('/cart/add-cart-line', {
        method: 'POST',
        body: JSON.stringify(data),
      });
      if (!updatedCart) return rejectWithValue();
      result = updatedCart;

      adobeAnalyticsData.products[0].quantity = '1';
      const newProduct = result.lineItems.find((x) => x.productId === product.productId && x.id !== externalId);
      adobeAnalyticsData.products[0].price =
        newProduct.discountedUnitPrice > 0 ? `${newProduct.discountedUnitPrice}` : `${newProduct.originalUnitPrice}`;
      adobeAnalyticsData.products[0].original_price = `${newProduct.originalUnitPrice}`;
    } else {
      const data = {
        LineItems: [
          {
            Id: externalId,
            Quantity: amount,
          },
        ],
      };
      result = await CommerceApiFetchWrapper('/cart/update-quantity', { method: 'POST', body: JSON.stringify(data) });
      if (!result.status == 200) return rejectWithValue();
    }
    adobeAnalyticsData.products[0].quantity = '1';

    // // analytics
    const quantity = product.quantity;
    if (amount > quantity) {
      // added
      dispatch({
        type: 'GA/ADD',
        payload: { product, quantity: amount - quantity, currencyCode: state.Cart.currencyCode },
      });

      adobeAnalyticsData.add_to_cart_variant = 'add_to_cart_cart';
      AdobeAnalyticsUtil.DataLayer.TrackEvent('cart_addition', adobeAnalyticsData);
      br_cartAddition(result);
    } else {
      // removed
      dispatch({
        type: 'GA/REMOVE',
        payload: { product, quantity: quantity - amount, currencyCode: state.Cart.currencyCode },
      });

      adobeAnalyticsData.remove_from_cart_variant = 'minus';
      adobeAnalyticsData.products[0].stock_status = product.isInStock ? 'In stock' : 'Out of stock';
      AdobeAnalyticsUtil.DataLayer.TrackEvent('cart_remove', adobeAnalyticsData);
      br_cartRemove(result);
    }
    // // end analytics

    window.dispatchEvent(new Event('cart-updated'));

    return result;
  }
);

export const removeProduct = createAsyncThunk(
  'removeProduct',
  async ({ externalId, adobeAnalyticsData }, { getState, rejectWithValue, dispatch }) => {
    if (externalId) {
      const state = getState();
      let result = await CommerceApiFetchWrapper(`/cart/line/${externalId}`, {
        method: 'DELETE',
      });
      if (!result.status == 200) return rejectWithValue();

      const product = state.Cart.lineItems.find((x) => x.id === externalId);
      const quantity = product.quantity;

      dispatch({
        type: 'GA/REMOVE',
        payload: { product, quantity, currencyCode: state.Cart.currencyCode },
      });

      adobeAnalyticsData.remove_from_cart_variant = 'trashcan';
      adobeAnalyticsData.products[0].stock_status = product.isInStock ? 'In stock' : 'Out of stock';
      adobeAnalyticsData.products[0].quantity = `${quantity}`;
      AdobeAnalyticsUtil.DataLayer.TrackEvent('cart_remove', adobeAnalyticsData);
      window.dispatchEvent(new Event('cart-updated'));

      if (result?.lineItems?.length === 0 && state.Cart.shippingInfo?.id) {
        var cart = await dispatch(updateShippingMethod(true));
        result = cart.payload;
      }
      br_cartRemove(result);
      return result;
    }
  }
);
